import React from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { useRootAppStore } from "@hooks";

export default function HeaderFailedLoginsButton() {
	const { failedLoginsCheckPopupStore } = useRootAppStore();
	const { t } = useTranslation();

	const openPopup = () => {
		failedLoginsCheckPopupStore.togglePopup();
	};

	return (
		<button
			onClick={openPopup}
			className={classnames(
				"header__logins btn",
				"btn--sml",
				"btn--primary--inverted btn--icon"
			)}
		>
			<i className="u-icon u-icon--med u-icon--failed-login" />
			<span className="header__logins__label">
				{t("specific:USER.CHECK_FAILED_LOGINS.FAILED_LOGINS_TITLE")}
			</span>
		</button>
	);
}
